import { render, staticRenderFns } from "./couponCard.vue?vue&type=template&id=3ff0e3ba&scoped=true&"
import script from "./couponCard.vue?vue&type=script&lang=js&"
export * from "./couponCard.vue?vue&type=script&lang=js&"
import style0 from "./couponCard.vue?vue&type=style&index=0&id=3ff0e3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0e3ba",
  null
  
)

export default component.exports